package com.eladfinish.bible.contest.di

import com.eladfinish.bible.contest.analytics.analyticsModule
import com.eladfinish.bible.contest.di.audio.audioCommonModule
import com.eladfinish.bible.contest.di.haptics.hapticsCommonModule
import com.eladfinish.bible.contest.di.shake.shakeModule
import com.eladfinish.bible.contest.features.verseWidget.verseWidgetModule
import com.eladfinish.bible.contest.logging.NapierCrashlyticsLog
import com.eladfinish.bible.contest.platform.isDesktop
import com.eladfinish.bible.contest.screens.mikud.di.mikudModule
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.remoteconfig.FirebaseRemoteConfig
import dev.gitlive.firebase.remoteconfig.remoteConfig
import kotlinx.coroutines.Dispatchers
import org.koin.dsl.module
import kotlin.coroutines.CoroutineContext
import kotlin.random.Random

val sharedModule = module {
    single { NapierCrashlyticsLog() }

    // The gitlive Firebase SDK has no JVM desktop target — it resolves to Android's runtime
    // classes there and crashes with "Default FirebaseApp is not initialized" the moment
    // Firebase.remoteConfig is touched. FirebaseRemoteConfigDataSourceImpl already requests this
    // via getOrNull() and no-ops without one, so simply don't register it on desktop — a Koin
    // single<T?> whose factory returns null still throws ("Single instance created couldn't
    // return value"), so omitting the definition entirely is what makes getOrNull() return null.
    if (!isDesktop) {
        single<FirebaseRemoteConfig> { Firebase.remoteConfig }
    }
    single { Firebase }

    single<CoroutineContext> { Dispatchers.Default }
    single<Random> { Random.Default }

    includes(
        platformModule,
        generalModule,
        dataModule,
        useCaseModule,
        repositoryModule,
        cachePlatformModule,
        generalPlatformModule,
        analyticsModule,
        presentationModule,
        mainScreenModule,
        americanQuestionsModule,
        browseModule,
        shonotModule,
        completeChapterModule,
        completeVerseModule,
        mikudModule,
        monopolyModule,
        openQuestionsModule,
        namesModule,
        pairMatchingModule,
        parashotModule,
        reportToGoogleFormModuleKMP,
        pyramidCrosswordModule,
        randomVerseModule,
        searchModule,
        verseWidgetModule,
        sortLexicographicallyModule,
        lexicographicalSortScreenModule,
        viewContentTabsModule,
        featureModule,
        hapticsCommonModule,
        audioCommonModule,
        shakeModule,
    )
}
